import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import CustomNotify from '../Notify';
import CSV from '../../utils/CSV';
import ExportController from '../../controllers/ExportController';
import config from '../../config';
import UserStore from '../../stores/UserStore';

const defProgress = { total: 0, uploaded: 0 };

function DataComponentTableExport({
                                      filter = {},
                                      sessionId,
                                      totalRows,
                                      settingKey,
                                      disabled,
                                  }) {
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(defProgress);
    const csv = useMemo(() => new CSV(), []);

    const t = useMemo(() => UserStore.getTranslation(), []);
    const staticNames = useMemo(() => t?.dataTable?.export || { error: 'Export error' }, [t]);

    const onEnd = useCallback((err) => {
        setLoading(false);
        setProgress(defProgress);
        if (err) CustomNotify(staticNames.error, 'error');
    }, [staticNames]);

    const onSuccess = useCallback((resp) => {
        const cpaUrl = config.cpaUrl;
        if (resp?.result === 'success') {
            window.location = cpaUrl + resp.link;
        } else {
            CustomNotify(resp?.error || staticNames.error);
        }
        setLoading(false);
    }, [staticNames]);

    const onError = useCallback(() => onEnd(true), [onEnd]);

    const onDownload = useCallback(() => {
        setLoading(true);
        const f = { ...filter, sessionId, totalRows };
        ExportController.getAllData(settingKey, f, onSuccess, onError);
    }, [filter, sessionId, totalRows, settingKey, onSuccess, onError]);

    return (
        <div>
            <Button
                loading={loading}
                disabled={disabled}
                progress={progress}
                text={<img src={require('img/icons/down-arrow.svg')} alt="" />}
                onClick={onDownload}
            />
        </div>
    );
}

DataComponentTableExport.propTypes = {
    data: PropTypes.array,
    filter: PropTypes.object,
    sessionId: PropTypes.any,
    totalRows: PropTypes.any,
    settingKey: PropTypes.any,
    disabled: PropTypes.bool,
};

export default DataComponentTableExport;
